import React from "react";
import "./Challenge.css";
import BackBtn from "../../Components/BackBtn/BackBtn";

export default function Challenge() {
  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="challengeWrapper responsiveWidth">
            <h3>به زودی...</h3>
            <div className="challenge centeredFlex">
              <div className="challengeImages">
                <img
                  className="flowerBg"
                  src="/images/ic_challenge_bg.svg"
                  alt="challenge icon"
                />
                <img
                  className="challengeImg"
                  src="/images/ic_fitness.svg"
                  alt="fitness icon"
                />
              </div>
              <p>از صبوری شما ممنونم</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
